import {Component, Vue} from 'vue-property-decorator';

@Component
export default class screenSizeMixin extends Vue {

    private screenSizeMixin_screenWidth = window.innerWidth;

    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    destroyed(){
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize(){
        this.screenSizeMixin_screenWidth = window.innerWidth;
    }
}